import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
const AddWorkShopCategory = () => {
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [isCheckedAttechemt, setCheckedAttechemt] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [dyamicField, setDynamicField] = useState([{ w_field_name: "", w_category_price: "" }]);
    const [addWorkShopCategory, setAddWorkShopCategory] = useState({
        event_name: eventName,
        w_category_name: "",
        w_category_descriptions: "",
        error_list: [],
    });
    const handleCheckboxChange = () => {
        setChecked(!isChecked);
    };
    const handleCheckboxChangeForAttechement = () => {
        setCheckedAttechemt(!isCheckedAttechemt);
    };

    const handleInput = (e) => {
        e.persist();
        setAddWorkShopCategory({ ...addWorkShopCategory, [e.target.name]: e.target.value });
    }

    const handleDynamicInput = (e, index) => {
        const { name, value } = e.target;
        const dyamicFieldValue = [...dyamicField];
        dyamicFieldValue[index][name] = value;
        setDynamicField(dyamicFieldValue);
    }
    const handleRemoveDynamicField = index => {
        const dyamicFieldValue = [...dyamicField];
        dyamicFieldValue.splice(index, 1);
        setDynamicField(dyamicFieldValue);

    }

    const handleAddDynamicField = () => {

        setDynamicField([...dyamicField, { w_field_name: "", w_category_price: "" }]);
    }

    const absCateSubmit = (e) => {

        e.preventDefault();

        const data = {
            eventid,
            event_name: addWorkShopCategory.event_name,
            workshop_category_name: addWorkShopCategory.w_category_name,
            workshop_category_descriptions: addWorkShopCategory.w_category_descriptions,
            dyamicField,
            isChecked,
            isCheckedAttechemt,

        }
        data.event_name == "" ? setdisabled(false) :
            data.w_category_name == "" ? setdisabled(false) :
                setdisabled(true)

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-category-store`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    history.push('/admin/workshop/category');
                }
                else {

                    setAddWorkShopCategory({ ...addWorkShopCategory, error_list: res.data.validate_error })

                }

            });


        });


    }
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
  
    
    return (

        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Add WorkShop Category
                        </Typography>
                        <Box component="form" onSubmit={absCateSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} >
                                    <TextField
                                        disabled
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Evnet Name"
                                        autoFocus
                                        name='event_name' onChange={handleInput}
                                        defaultValue={eventName || ""}
                                        helperText={addWorkShopCategory.error_list.title} />
                                </Grid>
                                

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Category Name"
                                        autoFocus
                                        name='w_category_name' onChange={handleInput}
                                        helperText={addWorkShopCategory.error_list.workshop_category_name} />
                                </Grid>

                                <Grid item xs={12} >

                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth

                                        label="Add Descriptions"
                                        autoFocus
                                        name='w_category_descriptions' onChange={handleInput}
                                        multiline
                                        rows={6}
                                        helperText={addWorkShopCategory.error_list.workshop_category_descriptions} />

                                </Grid>
                                
                                <Grid item xs={6} >
                                    <FormControlLabel  control={<Checkbox color="success" />}
                                        label="Coupon"
                                        color="success"
                                        onChange={handleCheckboxChange}  checked={isChecked} />
                                        <br></br>
                                    <Typography
                                        component="span" style={{ color: "#311b92", fontSize: "90%" }}>
                                         Coupon is {isChecked ? ' Applied' : ' Not Applied'}.
                                    </Typography>

                                </Grid>

                                <Grid item xs={6} >
                                    <FormControlLabel  control={<Checkbox color="success" />}
                                        label="Attachment"
                                        color="success"
                                        onChange={handleCheckboxChangeForAttechement}  checked={isCheckedAttechemt} />
                                    {/* <FormHelperText style={{ color: "#311b92", fontSize: "90%" }}> Attachment is {isCheckedAttechemt ? 'Required' : ' Not Required'}.</FormHelperText> */}
                                    <br></br>
                                    <Typography
                                        component="span" style={{ color: "#311b92", fontSize: "90%" }}>
                                        Attachment is {isCheckedAttechemt ? 'Required' : ' Not Required'}.
                                    </Typography>
                                </Grid>

                                {
                                    dyamicField && dyamicField.map((val, i) => {
                                        return (

                                            <React.Fragment key={i + 1}>
                                                <Grid item xs={4} >
                                                    <TextField
                                                        autoComplete="given-name"
                                                        required
                                                        fullWidth
                                                        label="Field name"
                                                        autoFocus
                                                        name='w_field_name' onChange={e => handleDynamicInput(e, i)} />
                                                </Grid>
                                                <Grid item xs={4} >
                                                    <TextField
                                                        autoComplete="given-name"
                                                        required
                                                        fullWidth
                                                        label="Price"
                                                        autoFocus
                                                        name='w_category_price' onChange={e => handleDynamicInput(e, i)}
                                                    />
                                                </Grid>

                                                <Grid item xs={4} >

                                                    {
                                                        dyamicField.length !== 1 &&
                                                        <Button
                                                            onClick={() => handleRemoveDynamicField(i)}
                                                            variant="contained"
                                                            sx={{ mt: 1, backgroundColor: backGroundButtonByEvent, }} >
                                                            Remove
                                                        </Button>
                                                    }
                                                    {
                                                        dyamicField.length - 1 === i &&
                                                        <Button
                                                            onClick={handleAddDynamicField}
                                                            variant="contained"
                                                            sx={{ m: 1, backgroundColor: backGroundButtonByEvent, }} >
                                                            Add New Row
                                                        </Button>
                                                    }
                                                </Grid>
                                            </React.Fragment>

                                        );
                                    })
                                }




                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Add WorkShop Category
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>

    );
}
export default AddWorkShopCategory;
